import { mixpanelService } from '@/lib/services/mixpanel/initializeMixPanel'
import useGlobalStore from '@/store/useGlobalStore'
import { getCookie, setCookie } from 'cookies-next'
import { useEffect } from 'react'
import { MixpanelEvent } from '@/lib/services/mixpanel/mixpanelEvent'
import { getAlpha2WithExceptions } from '@/components/Checkout/_helpers/functions/getAlpha2WithExceptions'
import { hydra } from '@/lib/services/Hydra'
import { getAuthCookie } from '@/lib/utils/shared/cookies/getAuthCookie'

export const useOldUserInitialize = () => {
  const {
    app: { alpha2, language },
    user: { isSignedIn },
  } = useGlobalStore()

  const initializeProperties = async () => {
    const customer = await hydra.getMe({
      hydraToken: getAuthCookie() as string,
    })
    if (!customer) {
      console.log('No customer data found, skipping initialization')
      return
    }

    const unicityId =
      typeof customer.id.unicity === 'object'
        ? (customer.id.unicity as { unicity: string }).unicity
        : customer.id.unicity

    mixpanelService.identify(unicityId)

    const enrollerId = customer.enroller.id.unicity.toString()
    const sponsorId = customer.sponsor.id.unicity.toString()

    mixpanelService.registerSuperProperties({
      enroller_id: enrollerId,
      sponsor_id: sponsorId || enrollerId,
      user_market: getAlpha2WithExceptions({ alpha2 }),
      user_market_extended: alpha2,
      user_language: language,
      is_user_logged_in: 'true',
      user_type: customer.type,
    })

    mixpanelService
      .setPeopleProperties({
        unicity_id: unicityId,
        enroller_id: enrollerId,
        sponsor_id: sponsorId || enrollerId,
        user_market: getAlpha2WithExceptions({ alpha2 }),
        user_market_extended: alpha2,
        user_language: language,
        membership_registration_date: customer.joinDate,
        user_type: customer.type,
      })
      .then(() => {
        setCookie('userInitilizedInMixpanel', true)
        console.log('Successfully initialized user in Mixpanel')
      })
      .catch(() => {})
  }

  useEffect(() => {
    // Check both isSignedIn and auth cookie
    if (!isSignedIn && !getAuthCookie()) {
      console.log('User not properly authenticated, skipping initialization')
      return
    }

    const isInitialized = getCookie('userInitilizedInMixpanel')
    if (isInitialized) {
      console.log('User already initialized in Mixpanel')
      return
    }

    initializeProperties()
      .then(() =>
        mixpanelService.trackEvent(
          MixpanelEvent.INITIALIZE_USER_PROFILE_FOR_OLD_USERS,
          {},
        ),
      )

      .catch((error) => {
        console.error('Failed to initialize user:', error)
      })
  }, [isSignedIn])
}
